import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import {
  menuicon,
  menuIcon_active,
  usermanagement,
  usermanagement_active,
  auditlog,
  auditlog_active,
  useList,
  useList_active,
} from '../../assets/images';
import rolemanagement_active from '../../assets/images/roleManagement_Active.svg';
import rolemanagement from '../../assets/images/roleManagement_Inactive.svg';
import Inventory from '../../assets/images/InventoryIcon.svg';
import InventoryActive from '../../assets/images/InventoryActiveIcon.svg';
import { Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHardDrive,
  faHouse,
  faLayerGroup,
  faListCheck,
  faMagnifyingGlassChart,
  faMicrochip,
  faServer,
  faUserShield,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
export interface MenuItem {
  label: string;
  icon: React.ReactElement;
  subMenu?: SubMenuItem[];
  submenuitems: string[];
  to?: string;
  route: string;
  id?: string;
  activeMenuIcon: React.ReactElement;
}

interface SubMenuItem {
  label: string;
  menu: string;
  permissionname: string;
  icon: (isActive: boolean) => React.ReactElement;
  to: string;
  id?: string;
}

interface Pagepermission {
  pagepermission: MenuItem[];
  collapseView: boolean;
}

export const menuItems: MenuItem[] = [
  {
    label: 'Dashboard',
    route: 'dashboard',
    to: '/dashboard',
    id: 'dashboard',
    icon: <FontAwesomeIcon icon={faHouse} className="sidebaricons" />,
    activeMenuIcon: <FontAwesomeIcon icon={faHouse} className="activeicons" />,
    submenuitems: [],
  },
  {
    label: 'IAM',
    route: 'iam',
    to: '/iam/role',
    id: 'roles',
    icon: <FontAwesomeIcon icon={faUserShield} className="sidebaricons" />,
    activeMenuIcon: (
      <FontAwesomeIcon icon={faUserShield} className="activeicons" />
    ),
    submenuitems: ['roles', 'users', 'audit'],
    subMenu: [
      {
        label: 'Role Management',
        menu: 'IAM',
        to: '/iam/role',
        id: 'roles::list',
        permissionname: 'roles',
        icon: (param: boolean) => {
          return (
            <FontAwesomeIcon
              icon={faListCheck}
              className={param ? 'activeicons' : 'sidebaricons'}
            />
          );
        },
      },
      {
        label: 'User Management',
        menu: 'IAM',
        to: '/iam/user',
        id: 'users::list',
        permissionname: 'users',
        icon: (param: boolean) => {
          return (
            <FontAwesomeIcon
              icon={faUsers}
              className={param ? 'activeicons' : 'sidebaricons'}
            />
          );
        },
      },
      {
        label: 'Global Audit Log',
        menu: 'IAM',
        to: '/iam/auditlog',
        id: 'globalAudit::list',
        permissionname: 'audit',
        icon: (param: boolean) => {
          return (
            <FontAwesomeIcon
              icon={faMagnifyingGlassChart}
              className={param ? 'activeicons' : 'sidebaricons'}
            />
          );
        },
      },
      {
        label: 'Dealer Management',
        menu: 'IAM',
        to: '/iam/dealermanagement',
        id: 'dealerManagement::list',
        permissionname: 'dealerManagement',
        icon: (param: boolean) => {
          return (
            <FontAwesomeIcon
              icon={faUsers}
              className={param ? 'activeicons' : 'sidebaricons'}
            />
          );
        },
      },
    ],
  },
  {
    label: 'Hardware Management',
    route: 'hardware',
    to: '/hardware/controller',
    id: 'controller',
    icon: <FontAwesomeIcon icon={faMicrochip} className="sidebaricons" />,
    activeMenuIcon: (
      <FontAwesomeIcon icon={faMicrochip} className="activeicons" />
    ),
    submenuitems: ['controller, equipments,category'],
    subMenu: [
      {
        label: 'controller Management',
        menu: 'Hardware Management',
        to: '/hardware/controller',
        permissionname: 'hardware',
        id: 'controllers::list',
        icon: (param: boolean) => {
          return (
            <FontAwesomeIcon
              icon={faHardDrive}
              className={param ? 'activeicons' : 'sidebaricons'}
            />
          );
        },
      },
      {
        label: 'Equipment Management',
        menu: 'Hardware Management',
        to: '/hardware/equipments',
        permissionname: 'hardware',
        id: 'equipments::list',
        icon: (param: boolean) => {
          return (
            <FontAwesomeIcon
              icon={faServer}
              className={param ? 'activeicons' : 'sidebaricons'}
            />
          );
        },
      },
      {
        label: 'Equipment Categories',
        menu: 'Hardware Management',
        to: '/hardware/category',
        permissionname: 'hardware',
        id: 'categories::list',
        icon: (param: boolean) => {
          return (
            <FontAwesomeIcon
              icon={faLayerGroup}
              className={param ? 'activeicons' : 'sidebaricons'}
            />
          );
        },
      },
    ],
  },
  {
    label: 'Manufacturing Unit',
    route: 'manufacture',
    to: '/manufacture/production',
    id: 'manufacture',
    icon: <img src={menuicon} alt="manufacture Icon" />,
    activeMenuIcon: <img src={menuIcon_active} alt="manufacture Icon" />,
    submenuitems: ['Production'],
    subMenu: [
      {
        label: 'Production',
        menu: 'manufacture',
        to: '/manufacture/production',
        permissionname: 'manufacture',
        icon: (param: boolean) => {
          return (
            <img
              width={18}
              src={param ? rolemanagement_active : rolemanagement}
              alt="Icon"
            />
          );
        },
      },
    ],
  },
  {
    label: 'Inventory',
    route: 'inventory',
    to: '/inventory',
    id: 'inventory',
    icon: <img src={Inventory} alt="manufacture Icon" />,
    activeMenuIcon: <img src={InventoryActive} alt="manufacture Icon" />,
    submenuitems: [],
  },
  {
    label: 'Customer Management',
    route: 'customermanagement',
    to: '/customermanagement',
    id: 'customermanagement',
    icon: <img src={usermanagement} alt="manufacture Icon" />,
    activeMenuIcon: <img src={usermanagement_active} alt="manufacture Icon" />,
    submenuitems: [],
  },
];

export const dealerMenuItems: MenuItem[] = [
  {
    label: 'Dashboard',
    route: 'dashboard',
    to: '/dashboard',
    id: 'dashboard',
    icon: <FontAwesomeIcon icon={faHouse} className="sidebaricons" />,
    activeMenuIcon: <FontAwesomeIcon icon={faHouse} className="activeicons" />,
    submenuitems: [],
  },
  {
    label: 'Equipment Management',
    route: 'equipmentmanagement',
    to: '/equipmentmanagement',
    id: 'equipmentmanagement',
    icon: <img src={Inventory} alt="manufacture Icon" />,
    activeMenuIcon: <img src={InventoryActive} alt="manufacture Icon" />,
    submenuitems: [],
  },
  {
    label: 'Customer Management',
    route: 'customermanagement',
    to: '/customermanagement',
    id: 'customermanagement',
    icon: <img src={usermanagement} alt="manufacture Icon" />,
    activeMenuIcon: <img src={usermanagement_active} alt="manufacture Icon" />,
    submenuitems: [],
  },
];

const NestedList: React.FC<Pagepermission> = ({
  pagepermission,
  collapseView,
}) => {
  const [allowPages, setAllowPages] = useState<MenuItem[]>([]);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [pagename, setPageName] = useState('/dashboard');
  const location = useLocation();

  useEffect(() => {
    const userRole = localStorage.getItem('role');
    const pageName = location.pathname.split('/')[1];
    setPageName(pageName);
    const checkindex = menuItems.findIndex((a) => {
      return location.pathname.split('/')[1] === a.route;
    });
    const checkDealerindex = dealerMenuItems.findIndex((a) => {
      return location.pathname.split('/')[1] === a.route;
    });

    if (userRole === 'dealer') {
      setOpenIndex(checkDealerindex >= 0 ? checkDealerindex : null);
    } else {
      setOpenIndex(checkindex >= 0 ? checkindex : null);
    }
  }, [location.pathname]);

  const handleClick = (index: number) => {
    setOpenIndex((prevOpenIndex) => (prevOpenIndex === index ? null : index));
  };

  const isMenuItemActive = (type: string, to?: string) => {
    if (type === 'menu') {
      return pagename === to?.split('/')[1];
    } else {
      if (to === '/iam/role') {
        return location.pathname.startsWith('/iam/role');
      } else if (to === '/iam/user') {
        return location.pathname.startsWith('/iam/user');
      } else if (to === '/iam/dealermanagement') {
        return location.pathname.startsWith('/iam/dealermanagement');
      } else if (to === '/hardware/controller') {
        return location.pathname.startsWith('/hardware/controller');
      } else if (to === '/hardware/equipments') {
        return location.pathname.startsWith('/hardware/equipments');
      } else if (to === '/manufacture/production') {
        return location.pathname.startsWith('/manufacture/production');
      } else {
        return location.pathname === to;
      }
    }
  };

  useEffect(() => {
    setAllowPages(pagepermission);
  }, [pagepermission.length > 0]);

  return (
    <List className="sidebar_list" component="nav">
      {allowPages?.length > 0 &&
        allowPages.map((menuItem: MenuItem, index: number) => (
          <React.Fragment key={index}>
            <Tooltip
              title={menuItem.label}
              placement="right"
              disableHoverListener={!collapseView}
            >
              <ListItemButton
                onClick={() => handleClick(index)}
                component={menuItem.to ? RouterLink : 'div'}
                to={menuItem.to}
                className={`${collapseView && 'collapseView_ListItemButton'} sidebar_list_menubtn`}
              >
                <ListItemIcon>
                  {isMenuItemActive('menu', menuItem.to)
                    ? menuItem.activeMenuIcon
                    : menuItem.icon}
                </ListItemIcon>
                {!collapseView && (
                  <ListItemText
                    primary={
                      <Typography
                        variant="body2"
                        className={`${isMenuItemActive('menu', menuItem.to) ? 'menu_item-active' : 'menu_item'}`}
                      >
                        {menuItem.label}
                      </Typography>
                    }
                  />
                )}
              </ListItemButton>
            </Tooltip>

            <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {menuItem.subMenu?.map(
                  (subMenuItem: SubMenuItem, subIndex: number) => (
                    <Tooltip
                      key={subIndex}
                      title={subMenuItem.label}
                      placement="right"
                      disableHoverListener={!collapseView}
                    >
                      <ListItemButton
                        className={`ListItemButton ${collapseView && 'collapseView_ListItemButton'}`}
                        component={RouterLink}
                        to={subMenuItem.to}
                        onClick={() => {
                          setPageName(subMenuItem.to);
                        }}
                      >
                        <ListItemIcon>
                          {subMenuItem.icon(
                            isMenuItemActive('submenu', subMenuItem.to),
                          )}
                        </ListItemIcon>
                        {!collapseView && (
                          <ListItemText
                            primary={
                              <Typography
                                variant="body2"
                                className={`${isMenuItemActive('submenu', subMenuItem.to) ? 'menu_item-active' : 'menu_item'}`}
                              >
                                {subMenuItem.label}
                              </Typography>
                            }
                          />
                        )}
                      </ListItemButton>
                    </Tooltip>
                  ),
                )}
              </List>
            </Collapse>
          </React.Fragment>
        ))}
    </List>
  );
};

export default NestedList;
